import TechStack from '../sections/TechStack';
import CTA from '../sections/CTA';

export default function TechnologiesPage() {
  return (
    <>
      <div className="page-top-spacer" />
      <TechStack />
      <CTA />
    </>
  );
}
